import axios from "axios";
import { Modal } from "antd";
import Colors from "./Colors";

let maintenanceModalOpen = false;

const MAINTENANCE_UNTIL = new Date("2026-08-09T16:00:00+07:00");

const formattedMaintenanceDate = MAINTENANCE_UNTIL.toLocaleString("id-ID", {
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
});

const formattedMaintenanceTime = MAINTENANCE_UNTIL.toLocaleString("id-ID", {
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Asia/Jakarta",
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 503) {
      if (!maintenanceModalOpen) {
        maintenanceModalOpen = true;

        Modal.confirm({
          centered: true,
          closable: false,
          maskClosable: false,
          icon: null,
          width: 400,
          cancelButtonProps: { style: { display: "none" } },
          okText: "Kembali ke Beranda",
          okButtonProps: {
            style: {
              backgroundColor: Colors.primary,
              borderColor: Colors.primary,
              height: 40,
              fontWeight: 600,
              width: "100%",
            },
          },
          content: (
            <div style={{ textAlign: "center", padding: "12px 4px 4px" }}>
              <div
                style={{
                  width: 64,
                  height: 64,
                  margin: "0 auto 16px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #FFF1EE 0%, #FFE4DE 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" stroke={Colors.primary} strokeWidth="1.6" />
                  <path d="M12 7v6l4 2" stroke={Colors.primary} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>

              <p style={{ fontSize: 17, fontWeight: 700, color: "#181C32", margin: "0 0 8px" }}>Sistem Sedang Maintenance</p>

              <p style={{ fontSize: 13, color: "#6B7280", lineHeight: 1.6, margin: "0 0 16px" }}>
                Fitur yang terintegrasi dengan <b style={{ color: "#374151" }}>SAP</b> sedang tidak dapat diakses karena proses maintenance sistem yang sedang berlangsung.
              </p>

              <div
                style={{
                  background: "#F9FAFB",
                  border: "1px solid #F0F1F3",
                  borderRadius: 12,
                  padding: "14px 16px",
                  marginBottom: 8,
                  textAlign: "left",
                }}
              >
                <p style={{ fontSize: 10, fontWeight: 600, letterSpacing: 0.5, color: "#9CA3AF", textTransform: "uppercase", margin: "0 0 4px" }}>Estimasi Kembali Normal</p>
                <p style={{ fontSize: 14, fontWeight: 700, color: "#181C32", margin: 0 }}>{formattedMaintenanceDate}</p>
                <p style={{ fontSize: 12, color: "#6B7280", margin: "2px 0 0" }}>Pukul {formattedMaintenanceTime} WIB</p>
              </div>
            </div>
          ),
          onOk: () => {
            maintenanceModalOpen = false;
            window.location.href = "/";
          },
        });
      }
    }
    return Promise.reject(error);
  },
);

export default axios;
